module.exports = __webpack_public_path__ + "img/hr.hr89b8c8a.svg";